import { createBill } from 'admin/actions/bills';
import { clearShops } from 'admin/actions/shops';
import ConfirmModal from 'admin/components/atoms/ConfirmModal';
import Label from 'admin/components/atoms/Label';
import Labeled from 'admin/components/atoms/Labeled';
import TextArea from 'admin/components/atoms/TextArea';
import ApiResult from 'admin/components/shared/ApiResult';
import BillForms from 'admin/components/shared/BillForms';
import Breadcrumb from 'admin/components/shared/Breadcrumb';
import React, { Component } from 'react';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import Button from '../../atoms/Buttons';
import QrCodeDrawer from '../../molecules/QrCodeDrawer';
import styles from './styles.scss';

const ModalWrapper = styled.div`
  ${Labeled} {
    display: grid;
    grid-template-columns: 1fr 4fr;
    grid-template-rows: auto;
    justify-items: left;
    margin-top: 10px;
  }

  ${Labeled} > ${Label} {
    grid-column: 1;
  }

  max-height: calc(100vh - 210px);
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-track {
    background: #fff;
    border-left: solid 1px #ececec;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 10px;
    box-shadow: inset 0 0 0 2px #fff;
  }

  ${TextArea} {
    width: 500px;
    resize: both;
    margin-bottom: 10px;
  }
`;

const ModalButtonsWrapper = styled.div`
  margin-top: 0.5rem;
  display: flex;
  gap: 0.5rem;
  justify-content: center;
`;

class CreateBills extends Component {
  constructor(props) {
    super(props);
    this.state = {
      qrUrl: '',
      apiResult: {},
      qrSize: 128,
      selectedShopName: '',
      billData: {},
      isModalOpen: false,
    };
  }

  onConfirm = () => {
    const data = {
      private_money_id: this.state.billData.private_money_id,
      additional_private_money_ids: this.state.billData.additional_private_moneys.map((x) => x.id),
      user_id: this.state.billData.user_id,
      amount: this.state.billData.amount,
      description: this.state.billData.description,
    };
    createBill(data)
      .then((bill) => {
        this.setState({ qrUrl: bill.token });
        this.flashApiResult({ message: '支払いQRコードの作成に成功しました', isError: false });
        this.setState({ selectedShopName: bill.user.name });
      })
      .catch((err) => {
        err.then((res) => {
          this.flashApiResult({ message: this.mapResponseMessage(res), isError: true });
        });
      });
    this.closeModal();
  };

  mapResponseMessage = (response) => {
    const typeMessageMap = {
      account_not_found: '発行店舗に指定マネーの口座が見つかりませんでした',
      unpermitted_admin_user: '操作権限がありません',
      invalid_parameters: {
        missing: {
          user_id: '発行店舗が選択されていません',
        },
        invalid: {
          user_id: '発行店舗が選択されていません',
          amount: '金額の指定が間違っています',
          private_money_id: 'マネーの指定が間違っています (予期しないエラー)', // プルダウンメニューでは正しいidしか指定できないはず
          description: '説明文が最大文字数(200文字)を越えています',
        },
      },
    };

    const value = typeMessageMap[response.type];
    if (value == null) return response.message;
    if (typeof value === 'string') {
      return value;
    }
    return (
      (response.errors.missing
        ? value.missing[response.errors.missing[0]]
        : value.invalid[response.errors.invalid[0]]) || '予期しないエラーが発生しました'
    );
  };

  flashApiResult({ message, isError = false }) {
    this.setState({ apiResult: { message, isError } });
    setTimeout(() => this.setState({ apiResult: {} }), 6000);
  }

  handleSubmit = (data) => {
    this.setState({ billData: data });
    this.openModal();
  };

  openModal = () => {
    this.setState({ isModalOpen: true });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false });
  };

  render() {
    const crumb = [
      { value: 'ホーム', href: '/', active: false },
      { value: '販促管理', href: '', active: true },
      { value: '支払いQRコード管理', href: '/promotion/bills', active: false },
      { value: '支払いQRコード新規発行', href: '', active: true },
    ];
    return (
      <div>
        <Breadcrumb items={crumb} />
        <div>
          <ApiResult
            message={this.state.apiResult.message}
            isError={this.state.apiResult.isError}
          />
          <BillForms onSubmit={this.handleSubmit} />
          <ConfirmModal
            isModalOpen={this.state.isModalOpen}
            closeModal={this.closeModal}
            title="以下の内容で支払いQRを発行します"
            form={
              <ModalWrapper>
                <Labeled labelText="マネー">{this.state.billData.private_money_name}</Labeled>
                <Labeled labelText={<div style={{ wordBreak: 'keep-all' }}>発行店舗</div>}>
                  <div style={{ wordBreak: 'break-word' }}>{this.state.billData.user_name}</div>
                </Labeled>
                <Labeled labelText="追加対応マネー">
                  {(this.state.billData.additional_private_moneys || [])
                    .map((x) => x.name)
                    .join(', ')}
                </Labeled>
                <Labeled labelText="支払い金額">{this.state.billData.amount}</Labeled>
                <Labeled labelText="説明文">
                  <TextArea readOnly defaultValue={this.state.billData.description} />
                </Labeled>
                <ModalButtonsWrapper>
                  <Button variant="neutral" onClick={this.closeModal}>
                    キャンセル
                  </Button>
                  <Button variant="contained" onClick={this.onConfirm}>
                    実行
                  </Button>
                </ModalButtonsWrapper>
              </ModalWrapper>
            }
          />
          <div styleName="qr-display-wrapper">
            {this.state.qrUrl ? (
              <div>
                <div>下記のQRコード(画像)をご利用ください</div>
                <QrCodeDrawer
                  uri={this.state.qrUrl}
                  name={this.state.selectedShopName}
                  qrSize={this.state.qrSize}
                  showUrl
                />
              </div>
            ) : (
              <div styleName="dummy-qr-code">
                <p>ここにQRコードが表示されます</p>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  shops: state.shop.shops.rows,
  user: state.user,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ clearShops }, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CSSModules(CreateBills, styles))
);
